const products = [
    {
        product_id: '1',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Kim Dien Do',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],

        amount: 2,
        description:
            'iPhone 14 Pro Max brings experiences not found on any previous iPhone generation with luxurious Deep Purple or Gold, 48MP camera for the first time, A16 Bionic chip and flexible Dynamic Island "pill" screen, flattering eyes.',
        image: 'https://cdn2.cellphones.com.vn/x358,webp,q100/media/catalog/product/v/_/v_ng_20.png',
        name: 'Apple iPhone 14 Pro Max',
        categoryName: 'Smartphone',
        category: {
            name: 'Smartphone',
        },
        price: 1100,
        rating_average: 5,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://images.moneycontrol.com/static-mcnews/2022/09/iphone-14-pro-max.jpg',
        },
    },

    {
        product_id: '2',
        reviews: [
            {
                id: 1,
                avatar: 'https://toanthaydinh.com/wp-content/uploads/2020/04/avatar-dep-tong-hop-hinh-anh-dai-dien-facebook-doc-va-y-nghia-30.jpg',
                name: 'Tin Nguyen',
                rating_average: 4,
                content: 'General is good but I cant connect bluetooth',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 4,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 0,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://assets.xboxservices.com/assets/0b/28/0b2854b9-a7e7-47dd-b4f8-a371567854b2.png?n=Xbox-Series-S_Buy-Box_0_01_829x799.png',
        name: 'Microsoft Xbox Series SConsole',
        categoryName: 'Gamepad',
        category: {
            name: 'Gamepad',
        },
        price: 239,
        rating_average: 4,
        specification: [
            { title: 'CPU', value: '8X Cores @ 3.6 GHz (3.4 GHz w/SMT) Custom Zen 2 CPU' },
            { title: 'GPU', value: '4 TFLOPS, 20 CUs @1.565 GHz Custom RDNA 2 GPU' },
            { title: 'MEMORY', value: '10GB GDDR6 128 bit-wide bus' },
            { title: 'Gaming Resolution', value: '1440p' },
            {
                title: 'SOUND',
                value: 'L-PCM, up to 7.1, Dolby Digital 5.1',
            },
            { title: 'PORTS & CONNECTIVITY', value: 'HDMI. 1x HDMI 2.1 port, USB. 3x USB 3.1 Gen 1 ports' },
        ],
        highlight: {
            content:
                'Pre-owned Certified products are inspected, cleaned and (if applicable) repaired to excellent functional standards. Buying Pre-owned extends a products life, reducing e-waste and raw material extraction.',
            image: 'https://m.media-amazon.com/images/I/B1vctF8ahUL._CR5,0,3253,1836_SR684,386_.jpg',
        },
    },
    {
        product_id: '3',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 50,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://m.media-amazon.com/images/I/91pjZAMbEUS._AC_SX679_.jpg',
        name: 'SAMSUNG Galaxy Tab S7',
        categoryName: 'Tablet',
        category: {
            name: 'Tablet',
        },
        price: 459,
        rating_average: 3,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://images.moneycontrol.com/static-mcnews/2022/09/iphone-14-pro-max.jpg',
        },
    },
    {
        product_id: '4',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 50,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://cdn.shopify.com/s/files/1/0461/1434/1028/products/103378.png?v=1666062800',
        name: 'Keychron K8 Pro Swappable RGB Backlight Aluminum',
        categoryName: 'Keyboard',
        category: {
            name: 'Keyboard',
        },
        price: 120,
        rating_average: 4,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://images.moneycontrol.com/static-mcnews/2022/09/iphone-14-pro-max.jpg',
        },
    },
    {
        product_id: '5',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 50,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://tanthanhdanh.vn/wp-content/uploads/2023/03/ARCTIS-NOVA-1-White-TTD-1.png',
        name: 'Arctis Nova Multi-System Gaming Headset',
        categoryName: 'Over-ear',
        category: {
            name: 'Over-ear',
        },
        price: 89,
        rating_average: 4,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://images.moneycontrol.com/static-mcnews/2022/09/iphone-14-pro-max.jpg',
        },
    },
    {
        product_id: '6',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 50,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://cdn.hoanghamobile.com/i/productlist/dsp/Uploads/2022/07/28/image-removebg-preview-3_637946139747835809.png',
        name: 'Razer DeathAdder Essential Gaming Mouse',
        categoryName: 'Mouse',
        category: {
            name: 'Mouse',
        },
        price: 45,
        rating_average: 5,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://images.moneycontrol.com/static-mcnews/2022/09/iphone-14-pro-max.jpg',
        },
    },
    {
        product_id: '7',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 50,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://res-3.cloudinary.com/grover/image/upload/v1659235138/sqmk8kykcmsgriqk1dpo.png',
        name: 'Pyle Wireless Portable Bluetooth Boombox Speaker',
        categoryName: 'Speaker',
        category: {
            name: 'Speaker',
        },
        price: 80,
        rating_average: 4,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://images.moneycontrol.com/static-mcnews/2022/09/iphone-14-pro-max.jpg',
        },
    },
    {
        product_id: '8',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 0,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://duhung.vn/wp-content/uploads/2022/08/Jabra-Elite-4-Active-4.png',
        name: 'Jabra Elite 4 Active',
        categoryName: 'In-ear',
        category: {
            name: 'In-ear',
        },
        price: 107,
        rating_average: 5,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://images.moneycontrol.com/static-mcnews/2022/09/iphone-14-pro-max.jpg',
        },
    },
    {
        product_id: '9',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 50,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://images.samsung.com/is/image/samsung/p6pim/ca/lc27f396fhnxza/gallery/ca-curved-cf390-46-lc27f396fhnxza-512429305?$650_519_PNG$',
        name: 'SAMSUNG 27-Inch CF39 Series',
        categoryName: 'Monitor',
        category: {
            name: 'Monitor',
        },
        price: 255,
        rating_average: 4,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'Find your best viewing position and stay comfortable by tilting the screen up to 5 degrees forward or 15 degrees backward. Flicker-Free technology, Blue Light Filter, you can enjoy ultra-smooth gameplay or working for all-day without any eyes uncomfort.',
            image: 'https://www.lenovo.com/medias/66BCKAC2UK-Gallery-Image-2.png?context=bWFzdGVyfHJvb3R8NDY2NzM5fGltYWdlL3BuZ3xoYzEvaDc4LzEzMTI5MzI4NTI1MzQyLnBuZ3xkMDBhMWYyNjMwNWIzZGUxYzY1NzAxYWI0YTlmYmI3MGQwZjZjNmQ3YzJlODU5OTk5YzA3MTM2Y2U1OGMxYmMz',
        },
    },
    {
        product_id: '10',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 10,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://laptopre.vn/upload/picture/picture-1634978417.png',
        name: 'Dell Inspiron 3515 Laptop',
        categoryName: 'Laptop',
        category: {
            name: 'Laptop',
        },
        price: 890,
        rating_average: 5,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://images.moneycontrol.com/static-mcnews/2022/09/iphone-14-pro-max.jpg',
        },
    },
    {
        product_id: '11',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 50,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://skytechgaming.com/wp-content/uploads/2021/08/ST-ChronosW-0284-AM-HeroMain.png',
        name: 'Skytech Chronos Gaming PC Desktop',
        categoryName: 'Desktop',
        category: {
            name: 'Desktop',
        },
        price: 1270,
        rating_average: 5,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://images.moneycontrol.com/static-mcnews/2022/09/iphone-14-pro-max.jpg',
        },
    },
    {
        product_id: '12',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 50,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://au-media.apjonlinecdn.com/catalog/product/6/N/6N0A8AA-1_T1681440839.png',
        name: 'HyperX Pulsefire Haste 2',
        categoryName: 'Mouse',
        category: {
            name: 'Mouse',
        },
        price: 45,
        rating_average: 5,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://images.moneycontrol.com/static-mcnews/2022/09/iphone-14-pro-max.jpg',
        },
    },
    {
        product_id: '13',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 0,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://static.wixstatic.com/media/131a7a_18e749a7f8b84ebf80de6084d7a9a47d~mv2.png/v1/fill/w_600,h_308,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/131a7a_18e749a7f8b84ebf80de6084d7a9a47d~mv2.png',
        name: 'ASUS ROG Falchion Ace 65% RGB',
        categoryName: 'Keyboard',
        category: {
            name: 'Keyboard',
        },
        price: 107,
        rating_average: 5,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://images.moneycontrol.com/static-mcnews/2022/09/iphone-14-pro-max.jpg',
        },
    },
    {
        product_id: '14',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 50,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://resource.logitech.com/content/dam/gaming/en/products/f310/f310-gallery-1.png',
        name: 'Logitech F310 Wired Gamepad Controller Console',
        categoryName: 'Gamepad',
        category: {
            name: 'Gamepad',
        },
        price: 20,
        rating_average: 5,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://images.moneycontrol.com/static-mcnews/2022/09/iphone-14-pro-max.jpg',
        },
    },
    {
        product_id: '15',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 50,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://ionevn.vn/wp-content/uploads/2022/11/tai-nghe-bluetooth-apple-airpods-pro-2nd-gen-ione-vn.png',
        name: 'Apple AirPods (2nd Generation)',
        categoryName: 'In-ear',
        category: {
            name: 'In-ear',
        },
        price: 50,
        rating_average: 5,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://images.moneycontrol.com/static-mcnews/2022/09/iphone-14-pro-max.jpg',
        },
    },
    {
        product_id: '16',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 50,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://product.hstatic.net/1000233206/product/lenovo-legion-5-15arh7-82re0035vn-r7-6800h_c0757113f8344a13999d9c57043733f6_1024x1024.png',
        name: 'Lenovo Legion 5 Pro Gaming Laptop',
        categoryName: 'Laptop',
        category: {
            name: 'Laptop',
        },
        price: 1307,
        rating_average: 5,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://images.moneycontrol.com/static-mcnews/2022/09/iphone-14-pro-max.jpg',
        },
    },
    {
        product_id: '17',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 50,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://dlcdnwebimgs.asus.com/gain/f93bdd99-47d7-4f97-8800-5a83d0bd46a6/',
        name: 'ASUS TUF Gaming F15 Gaming Laptop',
        categoryName: 'Laptop',
        category: {
            name: 'Laptop',
        },
        price: 699,
        rating_average: 5,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://images.moneycontrol.com/static-mcnews/2022/09/iphone-14-pro-max.jpg',
        },
    },
    {
        product_id: '18',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 50,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://www.eposaudio.com/globalassets/__pim/products/h6-series/h6pro---open---white/74ae949a-c0b7-495e-af9e-7a1b2fee2e86_22710_h6pro-open-white_a8_front-view_fullsizepng.png?width=860',
        name: 'EPOS Audio H6PRO Open Acoustic Gaming Headset',
        categoryName: 'Over-ear',
        category: {
            name: 'Over-ear',
        },
        price: 107,
        rating_average: 5,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://images.moneycontrol.com/static-mcnews/2022/09/iphone-14-pro-max.jpg',
        },
    },
    {
        product_id: '19',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 7,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://lzd-img-global.slatic.net/g/p/1e1da3ce66a9b921ded65dea70c62dbd.png_720x720q80.png',
        name: 'KOORUI 27 Inch Computer Monitor',
        categoryName: 'Monitor',
        category: {
            name: 'Monitor',
        },
        price: 122,
        rating_average: 5,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'Find your best viewing position and stay comfortable by tilting the screen up to 5 degrees forward or 15 degrees backward. Flicker-Free technology, Blue Light Filter, you can enjoy ultra-smooth gameplay or working for all-day without any eyes uncomfort.',
            image: 'https://www.lenovo.com/medias/66BCKAC2UK-Gallery-Image-2.png?context=bWFzdGVyfHJvb3R8NDY2NzM5fGltYWdlL3BuZ3xoYzEvaDc4LzEzMTI5MzI4NTI1MzQyLnBuZ3xkMDBhMWYyNjMwNWIzZGUxYzY1NzAxYWI0YTlmYmI3MGQwZjZjNmQ3YzJlODU5OTk5YzA3MTM2Y2U1OGMxYmMz',
        },
    },
    {
        product_id: '20',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 0,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://i.shgcdn.com/14170c55-9273-42f6-bee5-a3ad6cdc0697/-/format/auto/-/preview/3000x3000/-/quality/lighter/',
        name: 'Audeze Euclid in-Ear Audiophile',
        categoryName: 'In-ear',
        category: {
            name: 'In-ear',
        },
        price: 87,
        rating_average: 4,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://images.moneycontrol.com/static-mcnews/2022/09/iphone-14-pro-max.jpg',
        },
    },
    {
        product_id: '21',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 50,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://cdn.hoanghamobile.com/i/productlist/dsp/Uploads/2022/06/07/macbook-pro-m2-gray-1.png',
        name: 'Apple 2023 MacBook Pro Laptop M2 Pro',
        categoryName: 'Laptop',
        category: {
            name: 'Laptop',
        },
        price: 2445,
        rating_average: 5,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://photos5.appleinsider.com/gallery/52671-105295-New-2023-MacBook-pros-xl.jpg',
        },
    },
    {
        product_id: '22',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 50,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://cdn.shopify.com/s/files/1/0605/8842/5461/products/5075-JDA-__RGB.png?v=1678702498',
        name: 'AKKO 5075B Plus Dragon Ball Super Goku',
        categoryName: 'Keyboard',
        category: {
            name: 'Keyboard',
        },
        price: 100,
        rating_average: 5,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://images.moneycontrol.com/static-mcnews/2022/09/iphone-14-pro-max.jpg',
        },
    },
    {
        product_id: '23',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 50,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://www.notebookcheck.net/fileadmin/_processed_/3/6/csm_Lenovo_Yoga_9i_Gen_7_Front_Facing_Windows_11_d915a18c77.png',
        name: 'Lenovo Yoga 9i 14',
        categoryName: 'Laptop',
        category: {
            name: 'Laptop',
        },
        price: 339,
        rating_average: 3,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://images.moneycontrol.com/static-mcnews/2022/09/iphone-14-pro-max.jpg',
        },
    },
    {
        product_id: '24',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 50,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://cdn2.cellphones.com.vn/x358,webp,q100/media/catalog/product/1/_/1_74_10.png',
        name: 'Apple 2022 MacBook Pro Laptop',
        categoryName: 'Laptop',
        category: {
            name: 'Laptop',
        },
        price: 1350,
        rating_average: 4,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://photos5.appleinsider.com/gallery/52671-105295-New-2023-MacBook-pros-xl.jpg',
        },
    },
    {
        product_id: '25',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 50,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://images.acer.com/is/image/acer/Nitro5-AN515-58-wallpaper-logo-rgbkb-Black-01?$Product-Cards-XL$',
        name: 'Acer Nitro 5 AN515-58-525P',
        categoryName: 'Laptop',
        category: {
            name: 'Laptop',
        },
        price: 850,
        rating_average: 4,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://images.moneycontrol.com/static-mcnews/2022/09/iphone-14-pro-max.jpg',
        },
    },
    {
        product_id: '26',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 50,
        description:
            'Find your best viewing position and stay comfortable by tilting the screen up to 5 degrees forward or 15 degrees backward. Flicker-Free technology, Blue Light Filter, you can enjoy ultra-smooth gameplay or working for all-day without any eyes uncomfort.',
        image: 'https://laptop15.vn/wp-content/uploads/2023/02/manhinh.png',
        name: 'Philips 272E1GSJ 27" 144Hz Freesync',
        categoryName: 'Monitor',
        category: {
            name: 'Monitor',
        },
        price: 209,
        rating_average: 3,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'Find your best viewing position and stay comfortable by tilting the screen up to 5 degrees forward or 15 degrees backward. Flicker-Free technology, Blue Light Filter, you can enjoy ultra-smooth gameplay or working for all-day without any eyes uncomfort.',
            image: 'https://www.lenovo.com/medias/66BCKAC2UK-Gallery-Image-2.png?context=bWFzdGVyfHJvb3R8NDY2NzM5fGltYWdlL3BuZ3xoYzEvaDc4LzEzMTI5MzI4NTI1MzQyLnBuZ3xkMDBhMWYyNjMwNWIzZGUxYzY1NzAxYWI0YTlmYmI3MGQwZjZjNmQ3YzJlODU5OTk5YzA3MTM2Y2U1OGMxYmMz',
        },
    },
    {
        product_id: '27',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 5,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://file.hstatic.net/1000026716/file/gearvn-ban-phim-co-akko-3098b-multi-modes-blue-on-white-4_e755d44a4a1a436cb350321635698e2c_grande.png',
        name: 'AKKO 3098N Multi-modes Blue On White',
        categoryName: 'Keyboard',
        category: {
            name: 'Keyboard',
        },
        price: 155,
        rating_average: 4,
        specification: [
            { title: 'CPU', value: 'Apple A16 Bionic' },
            { title: 'RAM', value: 8 },
            { title: 'SCREEN', value: '6,7 inch' },
            { title: 'OS', value: 'iOS 16' },
            {
                title: 'FRONT-CAMERA',
                value: '48MP: 24 mm',
            },
            { title: 'BACK-CAMERA', value: '12MP: 13 mm, Ultrawide, Time Lapse, Deep Fusion, Panorama, Night Mode...' },
            { title: 'HARD DRIVE', value: 128 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '4323 mAh' },
            { title: 'COLOR', value: 'Gold' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://images.moneycontrol.com/static-mcnews/2022/09/iphone-14-pro-max.jpg',
        },
    },
    {
        product_id: '28',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 50,
        description:
            'This refurbished product has been professionally inspected and tested to work and look like new. How a product becomes part of Amazon Renewed, your destination for pre-owned, refurbished products: A customer buys a new product and returns it or trades it in for a newer or different model. That product is inspected and tested to work and look like new by Amazon-qualified suppliers. Then, the product is sold as an Amazon Renewed product on Amazon. If not satisfied with the purchase, renewed products are eligible for replacement or refund under the Amazon Renewed Guarantee.',
        image: 'https://dlcdnwebimgs.asus.com/gain/751E7672-D4BE-41E7-AAC1-C0E8B3A10DF5/w1000/h732',
        name: 'ASUS ROG Gladius III Wireless AimPoint',
        categoryName: 'Mouse',
        category: {
            name: 'Mouse',
        },
        price: 899,
        rating_average: 5,
        specification: [
            { title: 'CPU', value: 'Snapdragon 8 Gen 2' },
            { title: 'RAM', value: 8 },
            {
                title: 'SCREEN',
                value: '6.8" Dynamic AMOLED 2X Infinity-O QHD+ Edge Screen. 120Hz Adaptive Refresh Rate',
            },
            { title: 'OS', value: '	Android 13.0' },
            {
                title: 'FRONT-CAMERA',
                value: '12MP',
            },
            { title: 'BACK-CAMERA', value: '200MP Wide' },
            { title: 'HARD DRIVE', value: 256 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '5,000mAh' },
            { title: 'COLOR', value: 'Phantom Black' },
        ],
        highlight: {
            content:
                'With the iPhone 14 Pro Max, a new Action Mode uses the full sensor with a slight crop-in to correct for excess movement. It could negate the need for a gimbal in some cases. However, a limitation to Action Mode is it only works up to 2.8K at 60fps and needs a lot of light to do so. For smoother 4K footage, it is best to use a gimbal.',
            image: 'https://images.moneycontrol.com/static-mcnews/2022/09/iphone-14-pro-max.jpg',
        },
    },
    {
        product_id: '29',
        reviews: [
            {
                id: 1,
                avatar: 'https://thuthuat123.com/uploads/2018/01/27/Avatar-dep-nhat-2_112147.jpg',
                name: 'Khoi Tran',
                rating_average: 5,
                content: 'good product, nice camera but battery runs out fast, not recommended for gaming',
                datetime: '2022-10-15T10:30:00Z',
            },
            {
                id: 2,
                avatar: 'https://antimatter.vn/wp-content/uploads/2023/01/anh-avatar-dep-cute-ngau-nhat-the-gioi-cho-nam.jpg',
                name: 'Phung Vinh Dac',
                rating_average: 5,
                content: 'Very worth buying, the product is suitable for business people, technology people',
                datetime: '2022-11-20T15:45:00Z',
            },
        ],
        amount: 22,
        description:
            'S Series has a legacy of pushing the boundaries of what a smartphone can do. And with Galaxy S23 Ultra, we’re raising that bar again. Galaxy S23 Ultra is more than the next big step in mobile tech. With the highest camera resolution on a phone and stunning Night Mode powered by Nightography, you can share those big moments no matter the lighting. Plus, with the fastest Snapdragon processor yet, juggle high-intensity games, multiple apps or video calls with ease. Write, sketch, edit, create and share from anywhere with a built-in S Pen. And do all of the above on an incredibly large display built for gaming, streaming, creating and doing.',
        image: 'https://smartviets.com/upload/S23%20Series/s23-ultra-kem-600x600.png',
        name: 'SAMSUNG Galaxy S23 Ultra',
        categoryName: 'Smartphone',
        category: {
            name: 'Smartphone',
        },
        price: 1199,
        rating_average: 4,
        specification: [
            { title: 'CPU', value: 'Snapdragon 8 Gen 2' },
            { title: 'RAM', value: 8 },
            {
                title: 'SCREEN',
                value: '6.8" Dynamic AMOLED 2X Infinity-O QHD+ Edge Screen. 120Hz Adaptive Refresh Rate',
            },
            { title: 'OS', value: '	Android 13.0' },
            {
                title: 'FRONT-CAMERA',
                value: '12MP',
            },
            { title: 'BACK-CAMERA', value: '200MP Wide' },
            { title: 'HARD DRIVE', value: 256 },
            { title: 'SECURITY', value: 'FaceID' },
            { title: 'CHARGER', value: 'Lightning' },
            { title: 'BATTERY CAPACITY', value: '5,000mAh' },
            { title: 'COLOR', value: 'Phantom Black' },
        ],
        highlight: {
            content:
                'Manufacturer warranties may not apply in all cases, depending on factors like the use of the product, where the product was purchased, or who you purchased the product from. Please review the warranty carefully, and contact the manufacturer if you have any questions.',
            image: 'https://innovative.ng/wp-content/uploads/2023/02/Samsung-Galaxy-S23-Ultra-2023.webp',
        },
    },
];

export default products;
